/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetReleaseScheduleRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_release_schedule.pb'
import {GetReleaseScheduleResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_release_schedule.pb'


export const getReleaseSchedule = (request: GetReleaseScheduleRequest, options?: CashRequestOptions) => post<GetReleaseScheduleRequest, GetReleaseScheduleResponse>("/2.0/cash/get-release-schedule", request, {...options, rejectOnError: true })